import React, { useEffect, useState, createContext } from 'react'

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { useLocation } from 'react-router-dom';
import AppointmentsApi from "../../../../Classes/API/Appointments/AppointmentsApi";
import SearchStringOrIntReq from '../../../../Classes/Models/Requests/SearchStringOrIntReq';
import Swal from 'sweetalert2';
import AddTherapistToDay from './AddTherapistToDay';
import AppDayTable from './AppDayTable';



const index = () => {
    const { state } = useLocation();
    const [IsLoaded, setIsLoaded] = useState(false)
    const [AppDay, setAppDay] = useState({})


    useEffect(async () => {
        if (!IsLoaded) {
            await GetAppDayById(state.AppDay.id)
        }

    }, [IsLoaded])


    useEffect(() => {
      if(Object.keys(AppDay).length > 0){
          setIsLoaded(true)
      }
      else{
          setIsLoaded(false)
      }
     
    }, [AppDay])
    

    const GetAppDayById = async (Id) => {
        let req = new SearchStringOrIntReq();
        req.SearchInt = Id;

        let res = await AppointmentsApi.GetAppoinmentDayById(req);

        if (res.status == "Success") {
            setAppDay(res.data)
        }
        else {
            Swal.fire("Failed", res.message, "error");
        }
    }


    if(!IsLoaded){
        return(
            <div>
                Loading...
            </div>
        )
    }
    return (
        <DashboardLayout> 
            <DashboardNavbar />
            <AddTherapistToDay AppDay={AppDay} setIsLoaded={setIsLoaded} />
            <AppDayTable AppDay={AppDay} />
        </DashboardLayout>
    )
}

export default index